module.exports = __webpack_public_path__ + "img/2.9343eb7f.jpg";